// constants names taken from https://github.com/adaltas/node-http-status/blob/master/lib/index.js
/* eslint-disable import/prefer-default-export */
export const NOT_FOUND = 404;
